import React, { Component } from 'react'
import AdSlider from '../AdSlider'
import PropTypes from 'prop-types'

import WrapperSliderPlaceholder from './WrapperSliderPlaceholder'
import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'

import '@loyal_molecules/slider.css'
import '@loyal_modules/carousel/css/owl.carousel.css'
import '@loyal_modules/carousel/css/owl.theme.default.min.css'
import '@loyal_template/showcases.css'
import '@loyal_template/cssslider.css'
import { getBanner } from 'Shared/GTM/getBanner'

class WrapperSlider extends Component {
  constructor (props) {
    super(props)

    this.sendSliderLoaded = this.sendSliderLoaded.bind(this)
  }

  stateCarousel = false
  state = {
    checked: 0,
    ready: false,
    sliderLoaded: []
  }

  sendSliderLoaded (name) {
    let sliders = this.state.sliderLoaded
    sliders.push(name)
    this.setState({
      sliderLoaded: sliders
    })

    if (document.querySelectorAll('.csslider .cssslider-container li').length === sliders.length) {
      let items = []

      sliders.forEach(function (entry) {
        items.push({
          'id': entry,
          'name': entry
        })
      })
      getBanner(this.props.profile, 'enhanced-ecommerce', 'promotionImpression', items)
    }
  }

  componentWillMount () {
    this.setState({
      dotsSlider: 'd-none',
      slideReady: false
    })

    this.state.ready && this.setState({ ready: false })
  }

  promotionClick (promotionClick) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'event': 'promotionClick',
      'eventCategory': 'enhanced-ecommerce',
      'eventAction': 'promotionClick',
      'ecommerce': {
        'promoClick': {
          'promotions': [{
            'id': promotionClick,
            'name': promotionClick
          }]
        }
      }
    })
  }

  handleChange = idx => {
    this.setState({
      checked: idx
    })
  }

  render () {
    setTimeout(() => {
      !this.state.ready && this.setState({ ready: true })
    }, 3000)
    return (
      <ReactPlaceholder ready={this.state.ready} customPlaceholder={<WrapperSliderPlaceholder />}>
        <div className='container-slider container-fluid  py-2' aria-hidden='true'>
          <div className=' container pos-relative radius px-0'>
            <div className='csslider infinity'>
              {this.props.sliders.map((itemSlider, index) => (
                <input tabIndex='-1' aria-hidden='true' type='radio' name='dfpslides' key={index} id={`dpfslides_${index}`} className={`slider-position slider-position-${index}`} onChange={e => this.handleChange(index)} checked={index === this.state.checked} />
              ))}
              <ul className='cssslider-container'>
                {this.props.sliders.map((itemSlider, index) => (
                  <li aria-hidden='true' key={index} slider-position={index} className={`scrollable slider-position slider-position-${index}`} onClick={() => this.promotionClick(`slider-position-${index}`)}>
                    <AdSlider
                      accountDfp={itemSlider.accountDfp}
                      sliderName={itemSlider.sliderName}
                      sizeMapping={itemSlider.sizeMapping}
                      targeting={itemSlider.targeting}
                      collapseEmptyDivs
                      sliderPosition={`slider-position-${index}`}
                      sendSliderLoaded={this.sendSliderLoaded}
                    />
                  </li>)
                )}
              </ul>
              <div className='arrows'>
                {this.props.sliders.map((itemSlider, index) => (
                  <label aria-hidden='true' htmlFor={`dpfslides_${index}`} key={index} index={index} className={`slider-position-${index} slider-position`} />
                ))}
              </div>
              <div className={`navigation ${this.state.dotsSlider}`}>
                <div>
                  {this.props.sliders.map((itemSlider, index) => (
                    <label aria-hidden='true' key={index} htmlFor={`dpfslides_${index}`} className={`slider-position slider-position-${index}`} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactPlaceholder>
    )
  }
}

WrapperSlider.propTypes = {
  sliders: PropTypes.any,
  profile: PropTypes.object
}

export default WrapperSlider



// WEBPACK FOOTER //
// ./src/features/Slider/wrapperSlider/WrapperSlider.js